import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createMedicine } from "../../../Redux/actions/adminActions/medicineActions";
import { showToast } from "../../ToastMessage"; // your toast utility

const AddMedicineModal = ({ show, onHide, refresh }) => {
  const dispatch = useDispatch();
  const initialForm = {
    name: "",
    company: "",
    category: "",
    price: "",
    stock: "",
    lowStockLimit: 10,
    description: "",
  };
  const [form, setForm] = useState(initialForm);

  if (!show) return null;

  const submit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(
        createMedicine({
          ...form,
          price: Number(form.price),
          stock: Number(form.stock),
          lowStockLimit: Number(form.lowStockLimit),
        })
      );

      // Show toast
      showToast("Medicine added successfully!");

      // Reset form
      setForm(initialForm);
      refresh();
      // Close modal
      onHide();
    } catch (err) {
      showToast("Failed to add medicine!");
      console.error(err);
    }
  };

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content p-3">
          <h5>Add Medicine</h5>
          <form onSubmit={submit}>
            <div className="row g-2">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  required
                  placeholder="Name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>
              <div className="col-sm-6">
                <input
                  className="form-control"
                  placeholder="Company"
                  value={form.company}
                  onChange={(e) =>
                    setForm({ ...form, company: e.target.value })
                  }
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  placeholder="Category"
                  value={form.category}
                  onChange={(e) =>
                    setForm({ ...form, category: e.target.value })
                  }
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  required
                  type="number"
                  placeholder="Price"
                  value={form.price}
                  onChange={(e) => setForm({ ...form, price: e.target.value })}
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  required
                  type="number"
                  placeholder="Stock"
                  value={form.stock}
                  onChange={(e) => setForm({ ...form, stock: e.target.value })}
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Low stock limit"
                  value={form.lowStockLimit}
                  onChange={(e) =>
                    setForm({ ...form, lowStockLimit: e.target.value })
                  }
                />
              </div>
              <div className="col-12 mt-2">
                <textarea
                  className="form-control"
                  placeholder="Description (optional)"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="mt-3 d-flex gap-2">
              <button className="btn btn-primary" type="submit">
                Add
              </button>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={onHide}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMedicineModal;
